import updateSelectedServiceCallIndex from '../mutators/updateSelectedServiceCallIndex';
import { ServiceCallLog } from '../store/schema/FormsDiagnosticsStore';
import getStore from '../store/store';
import { observer } from 'mobx-react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { formatUserDateTime } from 'owa-datetime';
import * as React from 'react';
import { Inspector } from 'react-inspector';
import {
    copyToClipboard,
    createCopyEventListener,
    getObjectAsString,
} from 'owa-diagnostics/lib/utils/copyToClipboardUtils';
import {
    DetailsList,
    Selection,
    SelectionMode,
} from 'office-ui-fabric-react/lib/components/DetailsList';

const styles = require('./FormsDiagnosticsPanel.scss');

@observer
export default class FormsDiagnosticsPanel extends React.Component<any, any> {
    private selection: Selection;
    private copyEventListener: (e: ClipboardEvent) => void;

    private getKey = item => item.key;

    private getSelectedLogs = (): ServiceCallLog[] => {
        const { serviceCalls } = getStore();
        const displayedServiceCalls = serviceCalls.reverse(); // We reverse the list in the view, so we should reverse the collection here too. Otherwise, the indexes don't match up
        return this.selection.getSelectedIndices().map(index => displayedServiceCalls[index]);
    };

    constructor(props: any) {
        super(props);
        this.selection = new Selection({
            selectionMode: SelectionMode.multiple,
            onSelectionChanged: () => {
                if (this.selection.getSelectedCount() == 1) {
                    updateSelectedServiceCallIndex(Number(this.selection.getSelection()[0].key));
                }
            },
            canSelectItem: () => true,
            getKey: this.getKey,
        });

        this.copyEventListener = createCopyEventListener<ServiceCallLog>(
            this.getSelectedLogs,
            ['action', 'status', 'start', 'response', 'request', 'headers'],
            parseLog
        );
    }

    componentDidMount() {
        document.addEventListener('copy', this.copyEventListener);
    }

    componentWillUnmount() {
        document.removeEventListener('copy', this.copyEventListener);
    }

    render() {
        const { serviceCalls, selectedServiceCallIndex } = getStore();
        const calls = serviceCalls
            .map((serviceCall, index) => {
                return {
                    Action: serviceCall.action,
                    Status: serviceCall.status,
                    Start: formatUserDateTime(serviceCall.start),
                    key: index,
                };
            })
            .reverse();

        return (
            <div>
                <DefaultButton onClick={copyToClipboard} className={styles.button}>
                    {'Copy selected rows to clipboard'}
                </DefaultButton>
                <div className={styles.container}>
                    <div className={styles.table}>
                        <DetailsList
                            items={calls}
                            selection={this.selection}
                            selectionMode={SelectionMode.multiple}
                            setKey="forms"
                        />
                    </div>
                    {selectedServiceCallIndex != -1 && (
                        <div className={styles.rightPanel}>
                            {this.renderObject(
                                serviceCalls[selectedServiceCallIndex].response,
                                'Response',
                                serviceCalls[selectedServiceCallIndex].action
                            )}
                            {serviceCalls[selectedServiceCallIndex].request &&
                                this.renderObject(
                                    serviceCalls[selectedServiceCallIndex].request,
                                    'Request',
                                    serviceCalls[selectedServiceCallIndex].action
                                )}
                            {serviceCalls[selectedServiceCallIndex].headers &&
                                this.renderObject(
                                    serviceCalls[selectedServiceCallIndex].headers,
                                    'Headers',
                                    serviceCalls[selectedServiceCallIndex].action
                                )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private renderObject = (object: Object, title: string, action) => {
        return (
            <>
                <Label>{title}</Label>
                <Inspector data={object} expandLevel={this.getExpansionLevel(action)} />
            </>
        );
    };

    private getExpansionLevel = (action: string) => {
        switch (action) {
            case 'GetUserAvailabilityInternal':
                return 3;
        }
        return 6;
    };
}

const parseLog = (log: ServiceCallLog) => ({
    action: log.action,
    status: log.status,
    start: log.start.toString(),
    request: getObjectAsString(log.request),
    response: getObjectAsString(log.response),
    headers: getObjectAsString(log.headers),
});

export const renderPanel = () => <FormsDiagnosticsPanel />;
